<script setup lang="ts">
</script>

<template>
    <div class="loading">
        <div class="loading__spinner" />
    </div>
</template>

<style lang="scss" scoped>

.loading {
    width: 100%;
    height: 100%;
    min-height: 100px;
    text-align: center;
    position: relative;

    .loading__spinner {
        width: 20px;
        height: 20px;
        position: absolute;
        left: 48%;
        margin-left: -15px;
        margin-top: -30px;
        top: 50%;
    }

    .loading__spinner::after {
        content: "";
        display: block;
        width: 20px;
        height: 20px;
        margin: 8px;
        border-radius: 50%;
        border: 3px solid $slate-01;
        border-color: $slate-01 transparent $slate-01 transparent;
        animation: loading-spinner 1.2s linear infinite;
    }
}

@keyframes loading-spinner {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
